/* eslint-env browser */

import * as React from 'react'
const PropTypes = require('prop-types')
const classNames = require('classnames')

const GearItem = require('../Gear/GearItem')

class GearsGrid extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  render() {
    const { customItemClassName, simpleGrid, gears } = this.props

    return (
      <div className={classNames('columns is-mobile is-multiline is-centered', { 'is-gapless': !!simpleGrid })}>
        {gears.map(elt => (
          <div
            className={classNames('column', customItemClassName || 'is-6-mobile is-4-tablet is-3-desktop')}
            key={elt.productArticleId}
          >
            <GearItem gear={elt} productCategory={elt.productCategory || {}} />
          </div>
        ))}
      </div>
    )
  }
}

GearsGrid.propTypes = {
  gears: PropTypes.array.isRequired,
  simpleGrid: PropTypes.bool,
  customItemClassName: PropTypes.string,
}

GearsGrid.defaultProps = {
  simpleGrid: false,
  customItemClassName: null,
}

module.exports = GearsGrid
